module.exports = __webpack_public_path__ + "static/media/starterguidestep3.acbcae75.png";